import dynamic from "next/dynamic";

const Chart = dynamic(() => import("react-apexcharts"), {ssr: false});

const MONTHS = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec"
];

function fmtMonthDay(dateStr: string) {
  const d = new Date(dateStr);
  const m = MONTHS[d.getMonth()];
  const day = String(d.getDate()).padStart(2, "0");
  return `${m} ${day}`; // "Jan 03"
}

function fmtXAxis(dateStr: string) {
  const d = new Date(dateStr);
  const day = d.getDate(); // 28
  const mon = MONTHS[d.getMonth()]; // Dec
  return `${day}\n${mon}`; // two-line label
}

export default function FuelChart() {
  const categories = [
    "2024-12-28",
    "2024-12-29",
    "2024-12-30",
    "2024-12-31",
    "2025-01-01",
    "2025-01-02",
    "2025-01-03",
    "2025-01-04",
    "2025-01-05",
    "2025-01-06",
    "2025-01-07",
    "2025-01-08"
  ];

  const series = [
    {
      name: "Fuel Filling",
      data: [100, 240, 100, 50, 110, 240, 200, 50, 240, 50, 240, 240]
    },
    {name: "Theft", data: [10, 30, 70, 0, 0, 60, 120, 0, 20, 0, 50, 90]}
  ];

  const options: ApexCharts.ApexOptions = {
    chart: {
      type: "bar",
      stacked: true,
      toolbar: {show: false},
      parentHeightOffset: 0
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: "30%",
        borderRadius: 8,
        borderRadiusApplication: "end",
        borderRadiusWhenStacked: "last"
      }
    },
    stroke: {width: 0},
    dataLabels: {enabled: false},
    colors: ["#F59E0B", "#EF4444"],

    xaxis: {
      categories,
      labels: {
        formatter: val => fmtXAxis(String(val)),
        style: {colors: "#6B7280", fontSize: "12px"}
      },
      axisBorder: {show: false},
      axisTicks: {show: false}
    },

    yaxis: {
      title: {text: "Fuel Value (Litre)"},
      labels: {formatter: v => `${Math.round(v)} L`}
    },

    legend: {
      position: "bottom",
      horizontalAlign: "center"
      // markers: { width: 10, height: 4, radius: 2 }
    },

    tooltip: {
      shared: false,
      intersect: true,
      custom: ({series, seriesIndex, dataPointIndex, w}) => {
        const dateStr = String(w.globals.categoryLabels[dataPointIndex]);
        const value = series?.[seriesIndex]?.[dataPointIndex] ?? 0;

        // if you always want ↑ like screenshot:
        const arrow = "↑";

        return `
          <div style="background:#111827;color:#fff;padding:10px 12px;border-radius:8px;min-width:140px">
            <div style="font-weight:600;text-align:center">${fmtMonthDay(dateStr)}</div>
            <div style="margin-top:6px;display:flex;gap:6px;align-items:center;justify-content:center;font-size:12px">
              <span style="color:#F87171;font-weight:700">${arrow}</span>
              <span>${value} Litre</span>
            </div>
          </div>
        `;
      }
    }
  };

  return <Chart options={options} series={series} type="bar" height={180} />;
}
